import React, { createContext, useEffect, useState } from "react";
// import { getUser } from "./api/ChatRequest";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [modal, setModal] = useState(false);


 

  
  return (
    <UserContext.Provider
      value={{
       modal,setModal
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
